import { useEffect, useMemo, useState } from "react"
import { Button, Table, DatePicker, Select, message, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

interface channelInfo {
    id: string,
    channel_name: string
}

type fetchParams = {
    store_id: undefined | string,
    top_channel_id: undefined | string,
    merge_channel_id: undefined | string,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        top_channel_id: undefined,
        merge_channel_id: undefined,
        date: null
    }

    const [topChannelData, setTopChannelData] = useState<channelInfo[]>([])
    const [channelData, setChannelData] = useState<channelInfo[]>([])
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 汇总数据
    const [summaryData, setSummaryData] = useState<any>([])

    const [loading, setLoading] = useState<boolean>(false)
    const [summaryLoading, setSummaryLoading] = useState<boolean>(false)

    // 权限数据获取
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (fetchOtherParams.date) {
            fetch({ pagination, fetchOtherParams })
        }
    }, [pagination.current])

    useEffect(() => {
        // 查询渠道列表
        baseAxiosNoInfo('/markting_center/global/channel_list', {
            params: {
                p_id: ''
            }
        }).then((res: any) => {
            res && setTopChannelData(res)
        })
    }, [])

    // 查询合并渠道列表
    const getMergeChannelList = (value: String) => {
        baseAxiosNoInfo('/markting_center/global/merge_channel_list', {
            params: {
                p_id: value
            }
        }).then((res: any) => {
            res && setChannelData(res)
        })
    }

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        if (fetchOtherParams.date) {
            const p = { ...pagination }
            p.current = 1

            fetch({ pagination: p, fetchOtherParams })

        } else {
            message.error('必须选择日期')
        }
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        setSummaryLoading(true)

        // 清空汇总数据
        setSummaryData("")

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.month = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        axiosTable.get('/markting_center/report/sales_conver/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)

                // 设置汇总列表数据
                const { sales_conver_summary } = response
                if (sales_conver_summary && sales_conver_summary.length) {
                    setSummaryData(sales_conver_summary)
                }
            }

            setLoading(false)
            setSummaryLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    // 数据导出
    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.month = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        baseAxiosComplete('/markting_center/report/sales_conver/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    let channelOptions = channelData.map((el: channelInfo) => (<Option value={el.id} key={el.id}>{el.channel_name}</Option>))

    return (<div className="common-page">
        {/* 营销中心 -> 营销报表 -> 销售转化率 */}
        <BreadCrumb position={['营销中心', '销售转化率']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')
                    }} />
                </div>

                <Select allowClear style={{ width: 140, marginRight: 8, marginBottom: 12 }} placeholder="一级渠道" value={fetchOtherParams.top_channel_id}
                    onChange={(v: String) => {
                        handleChange(v, 'top_channel_id')
                        // 查询合并渠道列表
                        getMergeChannelList(v)
                    }}
                >
                    {topChannelData.map((el: channelInfo) => <Option value={el.id} key={el.channel_name}>{el.channel_name}</Option>)}
                </Select>
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="二级渠道"
                    value={fetchOtherParams.merge_channel_id}
                    onChange={(v: string) => { handleChange(v, 'merge_channel_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {channelOptions}
                </Select>

                <DatePicker style={{ width: '140px', marginRight: 8, marginBottom: 12 }} placeholder={'日期'} picker="month" value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="门店名称" dataIndex="store_name" key="store_name" />
                <Column title="销售名称" dataIndex="employee_name" key="employee_name" />
                <Column title="一级渠道" dataIndex="top_channel_name" key="top_channel_name" />
                <Column title="二级渠道" dataIndex="merge_channel_name" key="merge_channel_name" />
                <Column title="新增客资数" dataIndex="new_add_count" key="new_add_count" />
                <Column title="进店客资数" dataIndex="visit_store_count" key="visit_store_count" />
                <Column title="签单客资数" dataIndex="deal_count" key="deal_count" />
                <Column title="进店率" dataIndex="visit_store_per" key="visit_store_per" />
                <Column title="进店签单率" dataIndex="visit_deal_per" key="visit_deal_per" />
                <Column title="转化率" dataIndex="transfer_per" key="transfer_per" />
            </Table>
        </div>

        {/* 汇总数据 */}
        <div className="common-main">
            <h3>汇总</h3>

            <Table loading={summaryLoading} dataSource={summaryData} scroll={{ x: 'max-content' }} bordered={true} pagination={false}>
                <Column title="门店名称" dataIndex="store_name" key="store_name" />
                <Column title="销售名称" dataIndex="employee_name" key="employee_name" />
                <Column title="新增客资数" dataIndex="new_add_count" key="new_add_count" />
                <Column title="进店客资数" dataIndex="visit_store_count" key="visit_store_count" />
                <Column title="签单客资数" dataIndex="deal_count" key="deal_count" />
                <Column title="进店率" dataIndex="visit_store_per" key="visit_store_per" />
                <Column title="进店签单率" dataIndex="visit_deal_per" key="visit_deal_per" />
                <Column title="转化率" dataIndex="transfer_per" key="transfer_per" />
            </Table>
        </div>
    </div>)
}